import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VocabularyCategories } from "types/vocabulary/categories";

type Pagination = {
  page: number;
  size: number;
};

type Filters = {
  category: VocabularyCategories;
  search: string;
  location_uuid: string;
};

export interface InitialState {
  filtering: Filters;
  pagination: Pagination;
}

const initialState: InitialState = {
  filtering: {
    category: "reasons",
    search: "",
    location_uuid: "",
  },
  pagination: {
    page: 1,
    size: 10,
  },
};

export const vocabularyFiltersSlice = createSlice({
  name: "vocabularyFilters",
  initialState,
  reducers: {
    setPagination: (state, action: PayloadAction<Partial<Pagination>>) => {
      if (action.payload?.page) {
        state.pagination.page = action.payload.page;
      }
      if (action.payload?.size) {
        state.pagination.size = action.payload.size;
      }
    },

    setFilters: (state, action: PayloadAction<Partial<Filters>>) => {
      state.filtering = {
        category: action.payload?.category ?? "reasons",
        location_uuid: action.payload?.location_uuid ?? "",
        search: action.payload?.search ?? "",
      };
    },

    clearFilters: (state) => {
      state = {
        filtering: {
          category: "reasons",
          search: "",
          location_uuid: "",
        },
        pagination: {
          page: 1,
          size: 10,
        },
      };
    },
  },
});

export const { setPagination, setFilters, clearFilters } =
  vocabularyFiltersSlice.actions;

export default vocabularyFiltersSlice.reducer;
